import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { Droppable } from "react-beautiful-dnd";
import { KanbanContext } from "../Context/KanbanContext";
import { EGCard } from "../Card";
import { isToday } from "../../../helpers/common";
import { findEG } from "../utils";

const EGCards = props => {
    const { crewId, egList, isRequesting, search, crewFilteredList } = props;
    const context = useContext(KanbanContext);
    const [searchText, setSearchText] = useState(context.searchText);

    useEffect(() => {
        context.eventEmitter.addListener("@kanban/change_searchtext", crewId, text => setSearchText(text));
        return () => context.eventEmitter.removeListenerByName(crewId);
    }, []);

    return <Droppable key={crewId}
        disableInteractiveElementBlocking
        droppableId={crewId}
        isDropDisabled={!isToday(search.range) || isRequesting}
    >
        {(provided, snapshot) => (
            <div ref={provided.innerRef}
                className={`kanban-column-body kanban-cards ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
            >
                {isRequesting && <div className="mt-4 w-100 text-center">Loading...</div>}
                {!isRequesting && egList.map((eg, index) => (
                    <EGCard
                        key={eg.id}
                        index={index}
                        egId={eg.id}
                        crewId={crewId}
                        onFilter={e => findEG(e, { searchText, egIds: crewFilteredList })}
                    />
                ))}
                {provided.placeholder}
            </div>
        )}
    </Droppable>;
};

const mapStateToProps = (state, ownProps) => {
    const crew = state.crewKanban.crews.hasOwnProperty(ownProps.crewId) ?
        state.crewKanban.crews[ownProps.crewId] : null;
    return {
        egList: crew ? crew.egList : [],
        timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
        isRequesting: crew ? crew.isRequesting : false,
        filters: { isRecentlyUpdated: state.crewKanban.filters.isRecentlyUpdated },
        search: { range: state.analyze.searchParams.range },
        crewFilteredList: state.crewKanban.crewFilteredList
    };
};

export default connect(mapStateToProps)(EGCards);